"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[566],{

/***/ 1566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Showcase_RotationBanners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(3756);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/RotationBanners/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-bottom: -4px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  pointer-events: ",
        ";\n\n  > div {\n    aspect-ratio: 1280 / 400;\n    border-bottom: 1px solid ",
        ";\n\n    @media (max-width: 500px) {\n      aspect-ratio: 500 / 500;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  object-position: center;\n  object-fit: cover;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0;\n  background-color: transparent;\n\n  & li {\n    margin: 0 ",
        ";\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-1a8291cb-0"
})(_templateObject());
const WrapperSlide = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-1a8291cb-1"
})(_templateObject1(), (param)=>{
    let { href  } = param;
    return href ? "initial" : "none";
}, (p)=>p.theme.colors.border);
const Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1a8291cb-2"
})(_templateObject2());
const WrapperDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a8291cb-3"
})(_templateObject3(), (p)=>p.theme.spacing.small);
const Dots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a8291cb-4"
})(_templateObject4(), (p)=>p.theme.colors.background, (p)=>p.theme.spacing.nano, (p)=>p.theme.spacing.large);

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/RotationBanners/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 



const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    appendDots: (dots)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperDots, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    " ",
                    dots,
                    " "
                ]
            })
        }),
    customPaging: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dots, {})
};
const RotationBanners = (param)=>{
    let { showcase  } = param;
    const isScreenIn500px = (0,useMediaQuery/* useMediaQuery */.a)("(max-width: 500px)");
    const activeRotationBanners = !(showcase === null || showcase === void 0 ? void 0 : showcase.rotationBanners) || showcase.rotationBanners.length === 0 ? [] : showcase.rotationBanners.filter((rotationBanner)=>rotationBanner.status === "active");
    if (!activeRotationBanners || activeRotationBanners.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
            ...settings,
            children: activeRotationBanners.map((banner)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperSlide, {
                    href: banner.url || "",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                            alt: "Rotation banners",
                            src: !!banner.mobilePicture && isScreenIn500px ? banner.mobilePicture : banner.desktopPicture
                        })
                    })
                }, banner._id))
        })
    });
};
/* harmony default export */ var Showcase_RotationBanners = (RotationBanners);


/***/ })

}]);